import { useDispatch, useSelector } from "../../redux/hooks";
import { useEffect } from "react";
import { useIsNewEntry, usePostApi } from "../../hooks";
import { useParams } from "react-router-dom";
import { setNewEntryRequest } from "../../redux/slices/generatorFeaturesSlice";

/**
 * Custom hook to handle new entry requests that depend on lbeid property as new entries do not have lbeids and send them via API.
 *
 * @returns void
 */
const useNewEntryRequests = () => {
  const dispatch = useDispatch();
  const { newEntryRequests } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const { lbeidOrPartId, idType } = useParams();
  const isNewEntry = useIsNewEntry();
  const { post } = usePostApi();
  useEffect(() => {
    if (
      newEntryRequests?.length > 0 &&
      !isNewEntry &&
      idType &&
      lbeidOrPartId
    ) {
      newEntryRequests.forEach(r => {
        const populatedRequest = {
          ...r,
          body: {
            ...r.body,
            params: {
              ...r.body?.params,
              [idType]: lbeidOrPartId,
            },
          },
        };
        void post(populatedRequest);
      });
      dispatch(setNewEntryRequest([]));
    }
  }, [isNewEntry, newEntryRequests, lbeidOrPartId, idType]);
};
export default useNewEntryRequests;
